import React from "react";
import { Link } from "react-router-dom";
import { FiChevronRight, FiHome } from "react-icons/fi";

const PageHeader = ({ title, subtitle, breadcrumbs = [], actions = null, icon: Icon = null }) => {
  return (
    <div className="bg-white rounded-xl sm:rounded-2xl p-3 sm:p-5 mb-2 sm:mb-4 shadow-xs border border-gray-200/80 flex flex-col md:flex-row md:items-center justify-between gap-2.5 sm:gap-4 transition-all">
      <div className="flex items-center gap-2.5 sm:gap-4">
        {Icon && (
          <div className="w-8 h-8 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-purple-50 text-[rgba(152,14,255,255)] flex items-center justify-center text-base sm:text-2xl shrink-0 shadow-xs border border-purple-100">
            <Icon />
          </div>
        )}
        <div className="min-w-0 flex-1">
          {/* Breadcrumb path */}
          <nav className="flex items-center gap-1 text-[11px] sm:text-xs font-medium text-gray-400 mb-0.5">
            <Link to="/" className="flex items-center gap-1 hover:text-purple-600 transition-colors">
              <FiHome className="text-[10px] sm:text-xs" />
              <span>GoMeet</span>
            </Link>
            {breadcrumbs.map((crumb, idx) => (
              <React.Fragment key={idx}>
                <FiChevronRight className="text-gray-300 text-[10px] sm:text-xs shrink-0" />
                {crumb.path ? (
                  <Link to={crumb.path} className="hover:text-purple-600 transition-colors truncate">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-purple-600 font-semibold truncate">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>

          {/* Title & Subtitle */}
          <h2 className="text-base sm:text-2xl font-bold text-gray-900 m-0 tracking-tight flex items-center gap-2 truncate">
            {title}
          </h2>
          {subtitle && (
            <p className="text-[11px] sm:text-sm text-gray-500 m-0 mt-0.5 font-normal line-clamp-1 sm:line-clamp-none">
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {actions && (
        <div className="flex items-center gap-2 sm:gap-3 shrink-0 self-start md:self-center">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
